import { FC, useMemo } from "react";
import { Calendar } from "theme";
import { useSearchParams } from "react-router-dom";
import { convertStingToDate } from "../../../utils/dateHelpers.ts";
import { format } from "date-fns";

type DateSelectorProps = {
  enableWeekSelection?: boolean;
};

const DateSelector:FC<DateSelectorProps> = ({ enableWeekSelection}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentDate = useMemo(() => {
    return convertStingToDate(searchParams.get("d")) ?? new Date();
  }, [searchParams]);

  return (
    <Calendar
      enableWeekSelection={enableWeekSelection}
      onChange={(date) => {
        setSearchParams((prev) => {
          prev.set("d", date ? format(date, "yyyy-MM-dd") : "");

          return prev;
        });
      }}
      value={currentDate}
    />
  );
};

export default DateSelector;
